"use strict";
var Observable_1 = require('../../Observable');
var distinct_1 = require('../../operator/distinct');
Observable_1.Observable.prototype.distinct = distinct_1.distinct;
//# sourceMappingURL=distinct.js.map


//////////////////
// WEBPACK FOOTER
// /app/~/rxjs/add/operator/distinct.js
// module id = ../../../../rxjs/add/operator/distinct.js
// module chunks = 7